import { CityIcons } from "@/assets/cityIcons/cityIcons";

const Strings = {
    venueitemPerpage:12,
    itemPerpage:10,
    //TODO: dummy values. update the value before adding apis and states
    // logoUrl: "https://media.bookyourzone.com/logo-transparent.png",
    bzyLogo:"https://media.bookyourzone.com/BYZLogov2.png",
    logoUrl: "https://media.bookyourzone.com/BookYourZone_transparent.png",
    routerPath: {
        login: "/login"
    },
    venuefilter:{
        featured:"featured",
        priceLowToHigh:"priceLowToHigh",
        priceHighToLow:"priceHighToLow",
        newestFirst:"newestFirst",
        topRated:"topRated"
    },
    ToastTypes: {
        isErrorToast: true,
        isSuccessToast: true
    },
    secondsToMinus:60,
    LoginStrings: {
        session_expired: ""
    },
    LoginType: { GoogleOAuthSSO: "GoogleOAuthSSO", GoogleOneTapSSO: "GoogleOneTapSSO", Email: "Email", Phone: "Phone" },
    bookingstatus: {unavailable:"unavailable",booked:"booked", pending: "pending", confirmed: "confirmed", cancelled: "cancelled", failed: "failed", completed: "completed" ,hold:"hold"},
    paymentStatus: { pending: "pending", confirmed: "confirmed", cancelled: "cancelled", failed: "failed" },

    btnText: {
        paynow: "Pay Now",
        cancel: "Cancel",
        procced: "Proceed",
        slot_reserve_text: "This slot is temporarily reserved for you, pay within 5 minutes to confirm"
    },

     popularCities :{
         Mumbai: "Mumbai",
            Delhi:"Delhi-NCR",
            Bengaluru:"Bengaluru",
            Hyderabad:"Hyderabad",
            Chandigarh:"Chandigarh",
            Ahmedabad:"Ahmedabad",
            Pune:"Pune",
            Kolkata:"Kolkata",
            Chennai:"Chennai",
            Kochi:"Kochi"
     },

     popularCitiesArr : [
        { name: "Hyderabad", venueCount: 87,icon: CityIcons.hyderabad },
        { name: "Mumbai", venueCount: 156,icon: CityIcons.mumbai, width: 40, height: 40 },
        { name: "Delhi-NCR", venueCount: 142,icon: CityIcons.delhi },
        { name: "Bengaluru", venueCount: 128,icon: CityIcons.bengaluru },
        { name: "Chandigarh", venueCount: 128,icon: CityIcons.chandigarh, width: 60, height: 60 },
        { name: "Ahmedabad",venueCount: 54, icon: CityIcons.ahmedabad },
        { name: "Pune", venueCount: 98,icon: CityIcons.pune },
        { name: "Chennai", venueCount: 98, icon: CityIcons.chennai },
        { name: "Kolkata",venueCount: 65, icon: CityIcons.kolkata },
        { name: "Kochi",venueCount: 65, icon: CityIcons.kochi }
    ]


};

export default Strings;
